<template>
	
	<a class="card card--border card--link" :class="{ 'card--selected': selected, 'card--active': active, 'card--overdue': overdue }" @click.prevent="onClick" @dblclick="onDoubleClick">
		
		<TicketDetails :ticket="ticket" :showDescription="showDescription" :showFooter="showFooter"/>
		
		<h4 v-if="ticket.project" class="project-name"><img v-if="ticket.project.logo_url" v-bind:src="ticket.project.logo_url">{{ ticket.project.name }}</h4>
		
	</a>
	
</template>

<script>
	
	import TicketDetails from "@/components/TicketDetails";
	//import TicketTitle from "@/components/TicketTitle";
	
	export default {
		
		components: { TicketDetails },
		
		props: {
			
			ticket: { default() { return {}; } },
			
			selected: { default: false },
			active: { default: false },
			overdue: { default: false },
			
			showDescription: { default: true },
			showFooter: { default: true },
			
		},
		
		methods: {
			
			onClick(e) {
				this.$emit("on-click", { ticket: this.ticket });
			},
			
			onDoubleClick(e) {
				this.$emit("on-click", { ticket: this.ticket, doubleClick: true });
			},
			
		},
		
	}
	
</script>

<style scoped>
	
	.card {
		margin-bottom: 20px;
		display: block;
		transition: all .25s;
	}
	
	.card .project-name {
		margin: 20px 0 0 0;
		overflow: auto;
		line-height: 24px;
	}
	
	.card .project-name img {
		width: 24px;
		height: 24px;
		border-radius: 4px;
		margin-right: 8px;
		display: block;
		float: left;
		border: 1px solid rgba(0, 0, 0, 0.1);
		box-sizing: border-box;
	}
	
</style>


// WEBPACK FOOTER //
// src/components/TicketCard.vue